import type { RootState } from 'js/src/libs/RootState';
import type { GetRootState } from 'js/src/luminary/luminary-redux-connect-types';

type WaitForSelectorOptions<TArgs extends unknown[]> = {
    selector: (state: RootState, ...args: TArgs) => boolean;
    getState: GetRootState;
    args?: TArgs;
    timeout?: number;
};

export function waitForSelector<TArgs extends unknown[]>({
    selector,
    getState,
    args = [] as unknown as TArgs,
    timeout = 30000,
}: WaitForSelectorOptions<TArgs>): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        const start = performance.now();

        const check = (time: number) => {
            if (selector(getState(), ...args)) {
                resolve();
                return;
            }
            if (time - start > timeout) {
                reject(new Error('TIMEOUT'));
                return;
            }
            requestAnimationFrame(check);
        };

        requestAnimationFrame(check);
    });
}
